import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={12} cy={12} r={12} fill={props.fill || "#13CB75"} />
    <path
      d="M10.745 18.8521L4.48242 12.3285L6.08813 11.0101L9.70948 13.9182C11.1942 12.1126 14.4888 8.52628 19.0348 5.67505L19.4169 6.57932C15.2443 10.5025 11.8286 16.0286 10.745 18.8521Z"
      fill="white"
    />
  </svg>
);

export default SVGComponent;
